import {createNamespacedHelpers} from "vuex";
import moment from "moment-timezone";

// Store
const {
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
  mapState: mapStateOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  data() {
    return {
      defaultElements: "oceanWind",
      elements: [
        {label: '海上風', value: "oceanWind", icon: require("@/assets/images/weather/ocean_wind.svg")},
        {label: '波浪', value: "oceanWave", icon: require("@/assets/images/weather/ocean_wave.svg")},
        {label: '流れ', value: "oceanCurrent", icon: require("@/assets/images/weather/ocean_current.svg")},
      ],
      timer: null,
    };
  },
  computed: {
    ...mapGettersOfLiveMap(["getMetoceanInitialDatetime", "getCurrentMetoceanSourceLayerId", "getCurrentContourSourceLayerId","getWeatherDisplayedUnixTime"]),
    ...mapStateOfLiveMap(["showWeatherMenu", "showMetoceanValue", "showMetoceanGrid", "selectedMetoceanElement", "isTimeSyncMode", "showContour"]),
    showMetocean: {
      get()       { return this.showWeatherMenu },
      set(isShow) { this.SET_SHOW_WEATHER_MENU(isShow) }
    },
    toBeShowContour: {
      get()       { return this.showContour },
      set(isShow) { this.SET_SHOW_CONTOUR(isShow) }
    },
    showElementValue: {
      get()       { return this.showMetoceanValue },
      set(isShow) { this.SET_SHOW_METOCEAN_VALUE(isShow) }
    },
    showGrid: {
      get()       { return this.showMetoceanGrid },
      set(isShow) { this.SET_SHOW_METOCEAN_GRID(isShow) }
    },
    selectedElements: {
      get()       { return this.selectedMetoceanElement },
      set(val)    { this.SET_SELECTED_METOCEAN_ELEMENT(val) }
    },
    isTimeSync: {
      get()           { return this.isTimeSyncMode },
      set(isTimeSync) {
        console.log("isTimeSync:" + isTimeSync);
        if(!isTimeSync){
          this.SET_TIMESYNC_MODE(isTimeSync)
          this.timer = null;
          return
        }
  
        this.setTimer();
  
        this.updateCurrentTime();
        this.SET_TIMESYNC_MODE(isTimeSync)   
      }
    }
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_SELECTED_METOCEAN_ELEMENT",
      "SET_SHOW_WEATHER_MENU",
      "SET_SHOW_CONTOUR",
      "SET_UPDATE_METOCEAN_SOURCE_LAYER",
      "SET_METOCEAN_CURRENT_DATETIME",
      "SET_SHOW_METOCEAN_VALUE",
      "SET_SHOW_METOCEAN_GRID",
      "SET_TIMESYNC_MODE",
      "SET_CURRENT_WEATHER_SOURCE_LAYER",
      "SET_UPDATE_CONTOUR_SOURCE_LAYER"
    ]),
    setSelectedElements(val) {
      if(this.showMetocean) {
        this.selectedElements = val
      }
    },
    setTimer() {
      const currentMinutes = moment().format("m")
      const currentSecounds = moment().format("s")
      const timeoutMilliseconds = ((60 - currentMinutes) * 60 - currentSecounds) * 1000;
      this.timer = window.setTimeout(this.updateCurrentTime, timeoutMilliseconds)
    },
    updateCurrentTime() {
      const newMomentObjJST = moment().startOf("hour");
      const newMomentObjUTC = newMomentObjJST.clone().utc();
      const newDatetime = newMomentObjJST.format("M月D日 (dd) HH:mm");
      this.SET_METOCEAN_CURRENT_DATETIME(newDatetime);
      if (this.showWeatherMenu) {
        const currentSourceLayerId = this.getCurrentMetoceanSourceLayerId
        const newSourceLayerId = `metocean_${newMomentObjUTC.format('YYYYMMDDHHmm')}`

        this.SET_CURRENT_WEATHER_SOURCE_LAYER(newSourceLayerId)
        this.SET_UPDATE_METOCEAN_SOURCE_LAYER({
          isUpdate: true,
          oldSourceLayerId: currentSourceLayerId,
          newSourceLayerId: newSourceLayerId,
          displayedUnixTime: newMomentObjJST.unix()
        });
      }

      if (this.showContour) {
        const currentContourSourceLayerId = this.getCurrentContourSourceLayerId;
        const start = moment().utc().startOf("day");
        const diffHours = newMomentObjUTC.diff(start, "hours");

        const newContourSourceTime = start.add(Math.floor(diffHours / 6) * 6, "h").format("YYYYMMDDHHmm");
        const newContourSourceLayerId = `contour_${newContourSourceTime}`;
        if (currentContourSourceLayerId != newContourSourceLayerId) {
          this.SET_UPDATE_CONTOUR_SOURCE_LAYER({
            isUpdate: true,
            oldSourceLayerId: currentContourSourceLayerId,
            newSourceLayerId: newContourSourceLayerId,
            displayedUnixTime: newMomentObjUTC.unix()
          });
        }
      }

      this.setTimer()
    },
  },
  watch: {
    showMetocean(isShow) {
      if (isShow) {
        // 等圧線表示時に海象を表示した際、等圧線の表示時間を元に海象を表示
        const newMomentObjJST = this.getWeatherDisplayedUnixTime
          ? moment.unix(this.getWeatherDisplayedUnixTime)
          : moment().startOf("hour");
        const newMomentObjUTC = newMomentObjJST.clone().utc();
        let currentDatetime = newMomentObjJST.format('M月D日 (dd) HH:mm');
        this.SET_METOCEAN_CURRENT_DATETIME(currentDatetime)
        if(this.selectedMetoceanElement === null) {
          this.setSelectedElements(this.defaultElements);
        }
        let currentSourceLayerId = this.getCurrentMetoceanSourceLayerId
        if (!currentSourceLayerId) {
          let time = newMomentObjUTC.format('YYYYMMDDHHmm');
          currentSourceLayerId = `metocean_${time}`
        }
        this.SET_UPDATE_METOCEAN_SOURCE_LAYER({
          isUpdate: true,
          oldSourceLayerId: currentSourceLayerId,
          newSourceLayerId: currentSourceLayerId,
          displayedUnixTime: newMomentObjUTC.unix()
        });
      } else {
        let currentSourceLayerId = this.getCurrentMetoceanSourceLayerId;
        this.SET_UPDATE_METOCEAN_SOURCE_LAYER({
          isUpdate: false,
          oldSourceLayerId: currentSourceLayerId,
          newSourceLayerId: currentSourceLayerId,
          displayedUnixTime: null
        });
      }
      this.SET_SHOW_WEATHER_MENU(isShow)
    },
    showContour(isShow) {
      const currentContourSourceLayerId = this.getCurrentContourSourceLayerId;
      if (isShow) {
        // 等圧線 on
        // 海象表示時に等圧線を表示した際、海象の表示時間を元に等圧線を表示
        const newMomentObjJST = this.getWeatherDisplayedUnixTime
          ? moment.unix(this.getWeatherDisplayedUnixTime)
          : moment().startOf("hour");
        const newMomentObjUTC = newMomentObjJST.clone().utc();
        // 等圧線は6時間毎の時間のデータを表示する: e.g. UTC 2000-01-01 00:00, 2000-01-01 06:00, 2000-01-01 12:00, 2000-01-01 18:00
        const start = moment().utc().startOf("day");
        const diffHours = newMomentObjUTC.diff(start, "hours");
        const newContourSourceTime = start.add(Math.floor(diffHours / 6) * 6, "h").format("YYYYMMDDHHmm");
        const newContourSourceLayerId = `contour_${newContourSourceTime}`;
        if (currentContourSourceLayerId != newContourSourceLayerId) {
          this.SET_UPDATE_CONTOUR_SOURCE_LAYER({
            isUpdate: true,
            oldSourceLayerId: currentContourSourceLayerId,
            newSourceLayerId: newContourSourceLayerId,
            // displayedUnixTime: 等圧線表示時に海象を表示した際、海象の表示時間の計算に使用する
            displayedUnixTime: newMomentObjUTC.unix()
          });
        }
      } else {
        // 等圧線 off
        this.SET_UPDATE_CONTOUR_SOURCE_LAYER({
          isUpdate: false,
          oldSourceLayerId: currentContourSourceLayerId,
          newSourceLayerId: null,
          displayedUnixTime: null
        });
      }
    },
    showElementValue(isShow) {
      this.SET_SHOW_METOCEAN_VALUE(isShow)
    },
    showGrid(isShow) {
      this.SET_SHOW_METOCEAN_GRID(isShow)
    },
    selectedElements(element) {
      this.SET_SELECTED_METOCEAN_ELEMENT(element)
      if (this.showMetocean) {
        let currentSourceLayerId = this.getCurrentMetoceanSourceLayerId
        const newMomentObjJST = this.getWeatherDisplayedUnixTime
          ? moment.unix(this.getWeatherDisplayedUnixTime)
          : moment().startOf("hour");
        const newMomentObjUTC = newMomentObjJST.clone().utc();
        if (!currentSourceLayerId) {
          let time = newMomentObjUTC.format('YYYYMMDDHHmm')
          currentSourceLayerId = `metocean_${time}`
        }
        this.SET_UPDATE_METOCEAN_SOURCE_LAYER({
          isUpdate: true,
          oldSourceLayerId: currentSourceLayerId,
          newSourceLayerId: currentSourceLayerId,
          displayedUnixTime: newMomentObjUTC.unix()
        });
      }
    },
    selectedMetoceanElement(val) {
      this.selectedElements = val
    },
  },
  mounted() {
  }
};